// Compiled at 2026-05-13T13:50:05.286Z
// Compiled at 2026-05-13T13:50:05.286Z
// Compiled at 2026-05-13T13:50:05.286Z
// Auto-generated by Lowgile
export const BranchName = 'master';
const { enUS } = require('date-fns/locale')
export const AppModuleId = 'Llama', Languages = { "English": { "isoCode": "en-US", "shortName": "en", "displayName": "English" } }, DefaultLanguage = "English", DefaultScreen = ["Llama", "Home"] as [string, string], DateFnsLocales = { enUS };
